// importing essentials
import React, { useState, useEffect } from 'react'
import { Link, useHistory } from "react-router-dom";
import axios from 'axios'

// importing general contents
import Topnav from './Topnav'
import Sidenav from './Sidenav'
import Footer from './Footer'

// importing route screens
import CreateTable from '../PrivateScreens/Table/CreateTable'
import ShowTables from '../PrivateScreens/Table/ShowTables';
import AddUser from '../PrivateScreens/Users/AddUser';
import UpdateUser from '../PrivateScreens/Users/UpdateUser'
import AddRole from '../PrivateScreens/Roles/AddRole';
import ShowRoles from '../PrivateScreens/Roles/ShowRoles';
import UpdateRole from '../PrivateScreens/Roles/UpdateRole';
import ShowUsers from '../PrivateScreens/Users/ShowUsers';
import UpdatePassword from '../PrivateScreens/Users/UpdatePassword';
import ProfilePage from './ProfilePage';
import Dashboard from '../PrivateScreens/Dashboard';

function Content({ display, route }) {
    let history = useHistory();
    const [error, setError] = useState("");
    const [privateData, setPrivateData] = useState({});
    const [permissionOk, setPermissionOk] = useState(false);
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        // function
        const fetchPrivateData = async () => {

            try {
                const { data } = await axios.get(
                    `${process.env.REACT_APP_BACKLINK}/api/private`, { withCredentials: true }
                );

                setPrivateData(data.data);
                if (data.data.permissions.includes(route)) {
                    setPermissionOk(true)
                }
                setLoading(false);

            } catch (error) {
                setError("Fetched Error!!");
                history.push("/login");
            }
        }

        fetchPrivateData()

    }, [route, history]);

    return (
        <>
            {loading && <h1>Loading...</h1>}

            <div className="wrapper">
                {error && <h1>{error}</h1>}
                <Topnav />
                <h1>User<span>[</span>CRUD<span>]</span>Management</h1>
                <Sidenav
                    userName={privateData.name}
                    userImage={privateData.profileImage}
                    route={route}
                />
                {/* </div> */}
                <div className="content-wrapper">
                    {/* <!-- Content Header (Page header) --> */}
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h2 className="m-0">{display}</h2>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className=""><Link to="/">Home</Link></li>
                                        <li className="breadcrumb-item active">{route}</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- /.content-header --> */}

                    {/* <!-- Main content --> */}
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row mt-5">
                                {
                                    (() => {
                                        switch (route) {

                                            case '/dashboard':
                                                return (
                                                    <Dashboard check={permissionOk} />
                                                )

                                            case '/create-table':
                                                return (
                                                    <CreateTable check={permissionOk} userInfo={privateData} />
                                                )

                                            case '/add-role':
                                                return (
                                                    <AddRole check={permissionOk} userInfo={privateData} />
                                                )

                                            case '/add-user':
                                                return (
                                                    <AddUser check={permissionOk} userInfo={privateData} />
                                                )

                                            case '/show-roles':
                                                return (
                                                    <ShowRoles check={permissionOk} userInfo={privateData} />
                                                )

                                            case '/update-role/:id':
                                                return (
                                                    <UpdateRole check={permissionOk} userInfo={privateData} />
                                                )

                                            case '/show-users':
                                                return (
                                                    <ShowUsers check={permissionOk} userInfo={privateData} />
                                                )

                                            case '/profile':
                                                return (
                                                    <ProfilePage check={permissionOk} userInfo={privateData} />
                                                )

                                            case '/update-user/:id':
                                                return (
                                                    <UpdateUser loading={loading} check={permissionOk} userInfo={privateData} />
                                                )

                                            case '/update-password/:id':
                                                return (
                                                    <UpdatePassword loading={loading} userInfo={privateData} />
                                                )

                                            case '/show-tables':
                                                return (
                                                    <ShowTables check={permissionOk} />
                                                )

                                            default: return (<h1>Nothing to print</h1>)

                                        }
                                    })()}

                            </div>
                        </div>
                    </section>
                </div>

                <Footer />
            </div>


        </>
    )
}

export default Content
